import Typography from 'design-system/src/Components/Typography/Typography';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, {FC} from 'react';
import CountdownButton from './CountdownButton';
import { LiveEventInfos } from '../../../interfaces/liveEventInfos.interface';

interface LiveStreamWaitingRoomProps {
  posterUrl?: string;
  viewportHeight: number;
  eventInfos?: LiveEventInfos;
  cooldown?: boolean;
  cooldownLeft?: number;
}

const LiveStreamWaitingRoom: FC<LiveStreamWaitingRoomProps> = ({
  posterUrl,
  viewportHeight,
  eventInfos,
  cooldown,
  cooldownLeft
}) => {
  const {t} = useTranslation('ui');
  const start = t('global.start');
  const end = t('global.end');
  
  const {startDate, endDate, title, description, onRefresh} = eventInfos || {};

  const style: React.CSSProperties = {
    width: '100%',
    height: viewportHeight,
    minHeight: 320,
    background: '#18191A',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    boxSizing: 'border-box',
  };

  const imageStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: 900,
    maxHeight: '50vh',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
    margin: '32px 0 24px 0',
    objectFit: 'cover',
    background: '#222',
    display: posterUrl ? 'block' : 'none',
  };

  const infoStyle: React.CSSProperties = {
    color: '#fff',
    textAlign: 'center',
    maxWidth: 700,
    margin: '0 auto',
  };

  const titleBlock = title && (
    <Typography
      variant="h2"
      style={{color: '#fff', textAlign: 'center', marginBottom: 16}}>
      {title}
    </Typography>
  );

  const posterBlock = posterUrl && (
    <img src={posterUrl} alt="Live cover" style={imageStyle} />
  );

  const dateBlock = (startDate || endDate) && (
    <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      gap: 32,
      margin: '24px 0 12px 0',
    }}
  >
    {startDate && (
      <div
        style={{
          background: '#23272b',
          borderRadius: 12,
          padding: '12px 24px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span
          style={{
            background: '#ff6600',
            color: '#fff',
            borderRadius: 8,
            padding: '2px 10px',
            fontWeight: 600,
            fontSize: 13,
            marginRight: 8,
            letterSpacing: 1,
          }}
        >
          {start}
        </span>
        <span style={{ color: '#fff', fontWeight: 500 }}>
          {new Date(startDate).toLocaleString()}
        </span>
      </div>
    )}
    {endDate && (
      <div
        style={{
          background: '#23272b',
          borderRadius: 12,
          padding: '12px 24px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span
          style={{
            background: '#666',
            color: '#fff',
            borderRadius: 8,
            padding: '2px 10px',
            fontWeight: 600,
            fontSize: 13,
            marginRight: 8,
            letterSpacing: 1,
          }}
        >
          {end}
        </span>
        <span style={{ color: '#fff', fontWeight: 500 }}>
          {new Date(endDate).toLocaleString()}
        </span>
      </div>
    )}
  </div>
  );

  const countdownBlock = startDate && (
    <CountdownButton date={startDate} onRefresh={onRefresh} cooldown={cooldown} cooldownLeft={cooldownLeft}></CountdownButton>
  );

  const descriptionBlock = description && (
    <Typography variant="body1" style={{color: '#ccc', marginTop: 8}}>
      {description}
    </Typography>
  );

  return (
    <div style={style}>
      {titleBlock}
      {posterBlock}
      <div style={infoStyle}>
        {dateBlock}
        {descriptionBlock}
      </div>
      <div style={{marginTop: 24, display: 'flex', justifyContent: 'center'}}>
        {countdownBlock}
      </div>
    </div>
  );
};

export default LiveStreamWaitingRoom;
